export function normalizeEmailAddress(email: unknown): string {
  return String(email || "")
    .trim()
    .toLowerCase();
}

export function normalizeSenderDisplayName(displayName: unknown): string {
  return String(displayName || "")
    .trim()
    .replace(/\s+/g, " ");
}

export function normalizeOptionalEmailAddress(email: unknown): string | undefined {
  const normalized = normalizeEmailAddress(email);
  return normalized || undefined;
}

export function isValidEmailAddress(email: unknown): boolean {
  const normalized = normalizeEmailAddress(email);
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized);
}

export function isValidSenderDisplayName(displayName: unknown): boolean {
  const normalized = normalizeSenderDisplayName(displayName);
  return normalized.length <= 100 && !/[\r\n]/.test(String(displayName || ""));
}

export function formatEmailWithDisplayName(
  email: unknown,
  displayName: unknown,
): string {
  const normalizedEmail = normalizeEmailAddress(email);
  const normalizedDisplayName = normalizeSenderDisplayName(displayName);
  return normalizedDisplayName
    ? `${normalizedDisplayName} <${normalizedEmail}>`
    : normalizedEmail;
}

export function getEmailDomain(email: unknown): string {
  const normalized = normalizeEmailAddress(email);
  const atIndex = normalized.lastIndexOf("@");
  return atIndex >= 0 ? normalized.slice(atIndex + 1) : "";
}
